{
  "PROFILE_SETTINGS": {
    "LINK": "تنظیمات پروفایل",
    "TITLE": "تنظیمات پروفایل",
    "BTN_TEXT": "تغییر دادن پروفایل",
    "DELETE_AVATAR": "حذف آواتار",
    "AVATAR_DELETE_SUCCESS": "آواتار با موفقیت حذف شد",
    "AVATAR_DELETE_FAILED": "هنگام حذف آواتار خطایی رخ داده، لطفا دوباره امتحان کنید",
    "UPDATE_SUCCESS": "پروفایل شما با موفقیت به روز شد",
    "PASSWORD_UPDATE_SUCCESS": "رمز عبورتان عوض شد",
    "AFTER_EMAIL_CHANGED": "پروفایلتان با موفقیت تغییر یافت، اطلاعات ورود به سیستم تغییر کرده لذا لطفا مجددا به سیستم وارد شوید",
    "FORM": {
      "PICTURE": "عکس نمایه",
      "AVATAR": "عکس پروفایل",
      "ERROR": "لطفا ایرادات ذکر شده را برطرف کنید",
      "REMOVE_IMAGE": "حذف",
      "UPLOAD_IMAGE": "آپلود عکس",
      "UPDATE_IMAGE": "تغییر عکس",
      "PROFILE_SECTION": {
        "TITLE": "پروفایل",
        "NOTE": "آدرس ایمیل شما هویت شماست و برای ورود به سیستم استفاده می شود."
      },
      "SEND_MESSAGE": {
        "TITLE": "کلید میانبر برای ارسال پیام",
        "NOTE": "شما می‌توانید یک کلید میانبر (Enter یا Cmd/Ctrl+Enter) را بر اساس راحت بودن در نوشتن انتخاب کنید.",
        "UPDATE_SUCCESS": "تنظیمات شما با موفقیت به‌روزرسانی شد",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "به جای کلیک بر روی دکمه ارسال، با فشردن کلید Enter پیام ارسال کنید."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "به جای کلیک کردن بر روی دکمه ارسال، با فشردن کلید Cmd/Ctrl + enter پیام ارسال کنید."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your Chatwoot dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "پیش‌فرض",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "LANGUAGE": {
          "TITLE": "Preferred Language",
          "NOTE": "Choose the language you want to use.",
          "UPDATE_SUCCESS": "Your Language settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the language settings, please try again",
          "USE_ACCOUNT_DEFAULT": "Use account default"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "امضای پیام شخصی",
        "NOTE": "یک امضای منحصر به فرد ایجاد کنید تا در انتهای تمام پیام هایی که از هر صندوق ورودی ارسال می کنید نمایش داده شود. همچنین می‌توانید یک تصویر درون خطی اضافه کنید که در چت، ایمیل و صندوق‌های ورودی API پشتیبانی می‌شود.",
        "BTN_TEXT": "ذخیره امضای پیام",
        "API_ERROR": "امضا ذخیره نشد! دوباره امتحان کنید",
        "API_SUCCESS": "امضا با موفقیت ذخیره شد",
        "IMAGE_UPLOAD_ERROR": "تصویر ارسال نشد! دوباره امتحان کنید",
        "IMAGE_UPLOAD_SUCCESS": "تصویر با موفقیت اضافه شد. لطفا بر روی ذخیره کلیک کنید تا امضا ذخیره شود",
        "IMAGE_UPLOAD_SIZE_ERROR": "اندازه تصویر باید کمتر از {size} مگابایت باشد",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "امضای پیام",
        "ERROR": "امضای پیام نمی تواند خالی باشد",
        "PLACEHOLDER": "امضای پیام شخصی خود را در اینجا وارد کنید."
      },
      "PASSWORD_SECTION": {
        "TITLE": "رمز عبور",
        "NOTE": "تغییر دادن رمز عبور باعث می‌شود مجبور شوید دوباره به سیستم وارد شوید",
        "BTN_TEXT": "تغییر رمز عبور"
      },
      "SECURITY_SECTION": {
        "TITLE": "Security",
        "NOTE": "Manage additional security features for your account.",
        "MFA_BUTTON": "Manage Two-Factor Authentication"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "توکن دسترسی",
        "NOTE": "از این توکن برای دسترسی از طریق API استفاده می‌شود",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "کپی",
        "RESET": "Reset",
        "CONFIRM_RESET": "Are you sure?",
        "CONFIRM_HINT": "Click again to confirm",
        "RESET_SUCCESS": "توکن دسترسی با موفقیت بازسازی شد",
        "RESET_ERROR": "خطا در بازسازی توکن دسترسی. لطفا مجدد امتحان کنید"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "هیچکدام",
          "MINE": "اختصاص داده",
          "ALL": "همه",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "هیچکدام",
          "ASSIGNED": "مکالمات اختصاص داده شده",
          "ALL_CONVERSATIONS": "همه گفتگوها"
        },
        "DEFAULT_TONE": {
          "TITLE": "صدای هشدار:"
        },
        "CONDITIONS": {
          "TITLE": "شرط‌های هشدار:",
          "CONDITION_ONE": "فقط در صورتی که پنجره مرورگر فعال نباشد، هشدارهای صوتی را ارسال کنید",
          "CONDITION_TWO": "هر 30 ثانیه یک بار هشدار ارسال کنید تا زمانی که تمام مکالمات اختصاص داده شده خوانده شود"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "ادامه مطلب"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "اعلامیه‌ به ایمیل",
        "NOTE": "اینجا می‌توانید تنظیمات اعلامیه‌هایی که به ایمیل ارسال می‌شود تغییر دهید",
        "CONVERSATION_ASSIGNMENT": "هر وقت گفتگویی به من اختصاص داده شد،‌ ایمیل بفرست",
        "CONVERSATION_CREATION": "هر وقت گفتگوی جدیدی شروع شد برای من ایمیل بفرست",
        "CONVERSATION_MENTION": "هنگامی که از شما در گفتگو نام برده می‌شود، از طریق ایمیل آگاه‌سازی ارسال کن",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "با ایجاد پیام جدید در مکالمه اختصاصی ، اعلان های ایمیل را ارسال کنید",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "هنگامی که یک پیام جدید در یک مکالمه شرکت کننده ایجاد می شود، اعلان های ایمیل ارسال کنید",
        "SLA_MISSED_FIRST_RESPONSE": "هر وقت گفتگویی سیاست SLA مربوط به اولین زمان پاسخ را نقض کرد ایمیل ارسال کن",
        "SLA_MISSED_NEXT_RESPONSE": "هر وقت گفتگویی سیاست SLA مربوط به زمان پاسخ بعدی را نقض کرد ایمیل ارسال کن",
        "SLA_MISSED_RESOLUTION": "هر وقت گفتگویی سیاست SLA مربوط به زمان حل موضوع را نقض کرد ایمیل ارسال کن"
      },
      "NOTIFICATIONS": {
        "TITLE": "تنظیمات آگاه‌سازی",
        "TYPE_TITLE": "نوع آگاه‌سازی",
        "EMAIL": "ایمیل",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them"
      },
      "API": {
        "UPDATE_SUCCESS": "تغییرات تنظیمات اعلامیه‌ها با موفقیت ثبت شد",
        "UPDATE_ERROR": "در ثبت تغییرات اعلامیه‌ها اشکالی پیش آمد، لطفا دوباره امتحان کنید"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "پوش نوتیفیکیشن",
        "NOTE": "اینجا می‌توانید تنظیمات پوش نوتیفیکیشن را تغییر دهید",
        "CONVERSATION_ASSIGNMENT": "هر وقت گفتگویی به من اختصاص داده شد، برای من پوش نوتیفیکیشن بفرست",
        "CONVERSATION_CREATION": "هر وقت گفتگوی جدیدی شروع شد برای من پوش نوتیفیکیشن بفرست",
        "CONVERSATION_MENTION": "هنگامی که از شما در مکالمه نام برده می شود پوش نوتیفیکیشن ارسال کنید",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "وقتی پیام جدیدی در مکالمه اختصاص داده شده ایجاد می شود ، پوش نوتیفیکیشن را ارسال کنید",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "هنگامی که یک پیام جدید در یک مکالمه شرکت کننده ایجاد می شود، اعلان فشار ارسال کنید",
        "HAS_ENABLED_PUSH": "در این مرورگر پوش نوتیفیکیشن را فعال کرده‌اید",
        "REQUEST_PUSH": "فعال کردن پوش نوتیفیکیشن",
        "SLA_MISSED_FIRST_RESPONSE": "هر وقت گفتگویی سیاست SLA مربوط به اولین زمان پاسخ را نقض کرد پوش ارسال کن",
        "SLA_MISSED_NEXT_RESPONSE": "هر وقت گفتگویی سیاست SLA مربوط به زمان پاسخ بعدی را نقض کرد پوش ارسال کن",
        "SLA_MISSED_RESOLUTION": "هر وقت گفتگویی سیاست SLA مربوط به زمان حل موضوع را نقض کرد پوش ارسال کن"
      },
      "PROFILE_IMAGE": {
        "LABEL": "عکس پروفایل"
      },
      "NAME": {
        "LABEL": "نام کامل شما",
        "ERROR": "لطفا نام کامل معتبر وارد کنید",
        "PLACEHOLDER": "لطفا نام کامل خود را وارد کنید"
      },
      "DISPLAY_NAME": {
        "LABEL": "نام نمایشی",
        "ERROR": "لطفا یک نام نمایشی معتبر وارد کنید",
        "PLACEHOLDER": "لطفا یک نام نمایشی وارد کنید، این نام در گفتگوها نمایش داده می‌شود"
      },
      "AVAILABILITY": {
        "LABEL": "در دسترس",
        "STATUS": {
          "ONLINE": "آنلاین",
          "BUSY": "مشغول",
          "OFFLINE": "آفلاین"
        },
        "SET_AVAILABILITY_SUCCESS": "در دسترس بودن با موفقیت تنظیم شد",
        "SET_AVAILABILITY_ERROR": "در دسترس بودن تنظیم نشد، لطفا دوباره امتحان کنید",
        "IMPERSONATING_ERROR": "Cannot change availability while impersonating a user"
      },
      "EMAIL": {
        "LABEL": "ایمیل شما",
        "ERROR": "لطفا ایمیل خود را به شکل صحیح وارد کنید",
        "PLACEHOLDER": "لطفا ایمیل خود را وارد کنید، این ایمیل در گفتگوها دیده می‌شود"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "رمز عبور فعلی",
        "ERROR": "لطفاً رمز عبور فعلی را وارد کنید",
        "PLACEHOLDER": "لطفاً رمز عبور فعلی را وارد کنید"
      },
      "PASSWORD": {
        "LABEL": "رمز عبور جدید",
        "ERROR": "رمز عبور می‌بایست ۶ کاراکتر یا بیشتر باشد",
        "PLACEHOLDER": "لطفا رمز عبور جدیدی وارد کنید"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "تکرار رمز عبور",
        "ERROR": "تکرار رمز عبور می‌بایست با رمز عبور یکسان باشد",
        "PLACEHOLDER": "لطفا رمز عبور جدید را مجددا وارد کنید"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "تغییر",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "SELECTOR_SUBTITLE": "از لیست یکی از حساب‌ها را انتخاب کنید",
    "PROFILE_SETTINGS": "Profile settings",
    "YEAR_IN_REVIEW": "Year in Review",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "CHANGELOG": "Changelog",
    "LOGOUT": "Log out"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "روز تا اتمام دوره آزمایشی باقی است.",
    "TRAIL_BUTTON": "الان بخرید",
    "DELETED_USER": "کاربر حذف شده",
    "EMAIL_VERIFICATION_PENDING": "ظاهرا هنوز ایمیل خود را تایید نکرده اید. لطفا ایمیل خود را برای تایید بررسی کنید.",
    "RESEND_VERIFICATION_MAIL": "ارسال مجدد ایمیل تایید",
    "EMAIL_VERIFICATION_SENT": "ایمیل تایید ارسال شد. لطفا ایمیل خود را بررسی کنید.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "حساب‌کاربری معلق شده است",
      "MESSAGE": "حساب‌کاربری شما به حالت تعلیق درآمده. لطفا برای اطلاعات بیشتر با تیم پشتیبانی تماس بگیرید."
    },
    "NO_ACCOUNTS": {
      "TITLE": "No account found",
      "MESSAGE_CLOUD": "You are not part of any accounts right now. If you think this is a mistake, please reach out to our support team.",
      "MESSAGE_SELF_HOSTED": "You are not part of any accounts right now. Please reach out to your administrator.",
      "LOGOUT": "Log out"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "کپی",
      "CODEPEN": "در CodePen باز کنید",
      "COPY_SUCCESSFUL": "کد به حافظه کپی شد"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "نمایش بیشتر",
      "SHOW_LESS": "نمایش کمتر"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "دانلود",
      "UPLOADING": "در حال آپلود...",
      "INSTAGRAM_STORY_UNAVAILABLE": "این داستان دیگر در دسترس نیست.",
      "INSTAGRAM_STORY_REPLY": "به استوری شما پاسخ داده:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "مشاهده‌ بر روی نقشه"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "ثبت"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "در حال تایید...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "اضافه کردن صندوق ورودی"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "در حال مشاهده:",
    "SWITCH": "تعویض",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "گفتگوها",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "همه گفتگوها",
    "MENTIONED_CONVERSATIONS": "اشاره",
    "PARTICIPATING_CONVERSATIONS": "شرکت کننده",
    "UNATTENDED_CONVERSATIONS": "بی سرپرست",
    "REPORTS": "گزارشات",
    "SETTINGS": "تنظیمات",
    "CONTACTS": "مخاطبین",
    "ACTIVE": "فعال",
    "COMPANIES": "شرکت ها",
    "ALL_COMPANIES": "All Companies",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_OVERVIEW": "بررسی اجمالی",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "CAPTAIN_TOOLS": "Tools",
    "CAPTAIN_SCENARIOS": "Scenarios",
    "CAPTAIN_PLAYGROUND": "Playground",
    "CAPTAIN_INBOXES": "صندوق‌های ورودی",
    "CAPTAIN_SETTINGS": "تنظیمات",
    "HOME": "صفحه اصلی",
    "AGENTS": "ایجنت ها",
    "AGENT_BOTS": "ربات‌ها",
    "AUDIT_LOGS": "بررسی لاگ هاگزارش های حسابرسی",
    "INBOXES": "صندوق‌های ورودی",
    "NOTIFICATIONS": "اعلان ها",
    "CANNED_RESPONSES": "پاسخ‌های آماده",
    "INTEGRATIONS": "برنامه‌های تلفیق شده",
    "DATA": "Data",
    "PROFILE_SETTINGS": "تنظیمات پروفایل",
    "ACCOUNT_SETTINGS": "تنظیمات حساب",
    "APPLICATIONS": "برنامه های کاربردی",
    "LABELS": "برچسب‌ها",
    "CUSTOM_ATTRIBUTES": "ویژگی‌های سفارشی",
    "AUTOMATION": "خودکارسازی",
    "MACROS": "ماکروها",
    "TEAMS": "تیم‌ها",
    "BILLING": "صورتحساب",
    "CUSTOM_VIEWS_FOLDER": "پوشه‌ها",
    "CUSTOM_VIEWS_SEGMENTS": "بخش ها",
    "ALL_CONTACTS": "تمام مخاطبین",
    "TAGGED_WITH": "برچسب گذاری شده با",
    "NEW_LABEL": "برچسب جدید",
    "NEW_TEAM": "تیم جدید",
    "NEW_INBOX": "صندوق ورودی جدید",
    "REPORTS_CONVERSATION": "گفتگوها",
    "CSAT": "رضایت مشتری",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "کمپین ها",
    "ONGOING": "درحال انجام",
    "ONE_OFF": "یکبار مصرف",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "ربات",
    "REPORTS_AGENT": "ایجنت ها",
    "REPORTS_LABEL": "برچسب‌ها",
    "REPORTS_INBOX": "صندوق ورودی",
    "REPORTS_TEAM": "تیم‌",
    "AGENT_ASSIGNMENT": "Agent Assignment",
    "SET_AVAILABILITY_TITLE": "خود را به عنوان",
    "SET_YOUR_AVAILABILITY": "در دسترس بودن خود را تنظیم کنید",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "BETA": "آزمایشی",
    "REPORTS_OVERVIEW": "بررسی اجمالی",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "مرکز راهنما",
      "ARTICLES": "Articles",
      "CATEGORIES": "دسته‌بندی‌ها",
      "LOCALES": "زبان‌های محلی",
      "SETTINGS": "تنظیمات"
    },
    "CHANNELS": "کانال‌ها",
    "SET_AUTO_OFFLINE": {
      "TEXT": "علامت گذاری خودکار به صورت آفلاین",
      "INFO_TEXT": "هنگامی که از برنامه یا پیشخوان استفاده نمی‌کنید، به سیستم اجازه دهید به طور خودکار شما را به صورت آفلاین علامت گذاری کند.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "SORT_TOOLTIP": "ترتیب",
    "SORT_BY": "مرتب‌سازی براساس",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "اسناد را بخوانید",
    "SECURITY": "Security",
    "CAPTAIN_AI": "Captain",
    "CONVERSATION_WORKFLOW": "Conversation Workflow"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "تزریق کردن",
      "EXPORT": "خروجی گرفتن"
    },
    "TYPES": {
      "CONTACTS": "مخاطبین",
      "CONVERSATIONS": "گفتگوها",
      "MESSAGES": "پیام‌ها"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "انصراف",
      "IMPORT": "تزریق کردن"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "Coming soon"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "تزریق کردن",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "نام",
      "TYPE": "نوع",
      "STATUS": "وضعیت",
      "IMPORTED": "Imported",
      "CREATED": "ایجاد شده",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "ایجاد شده",
      "DURATION": "مدت زمان",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "همه",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "پیام"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "تازه کردن",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "تکمیل شد",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "Captain Settings",
    "DESCRIPTION": "Configure your AI models and features for Captain. Captain follows a credit based billing, you will be charged credits for every action Captain takes based on the model selected.",
    "LOADING": "Loading Captain configuration...",
    "LINK_TEXT": "Learn more about Captain Credits",
    "NOT_ENABLED": "Captain is not enabled for your account. Please upgrade your plan to access Captain features.",
    "MODEL_CONFIG": {
      "TITLE": "Model Configuration",
      "DESCRIPTION": "Select AI models for different features.",
      "SELECT_MODEL": "Select model",
      "CREDITS_PER_MESSAGE": "{credits} credit/message",
      "COMING_SOON": "Coming soon",
      "EDITOR": {
        "TITLE": "Editor Features",
        "DESCRIPTION": "Powers smart compose, grammar corrections, tone adjustments, and content enhancement in your message editor."
      },
      "ASSISTANT": {
        "TITLE": "Assistant",
        "DESCRIPTION": "Handles automated responses, conversation summaries, and intelligent reply suggestions for customer interactions."
      },
      "COPILOT": {
        "TITLE": "Co-pilot",
        "DESCRIPTION": "Provides real-time contextual suggestions, knowledge base recommendations, and proactive insights during conversations."
      }
    },
    "FEATURES": {
      "TITLE": "امکانات",
      "DESCRIPTION": "Enable or disable AI-powered features.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Audio Transcription",
        "DESCRIPTION": "Automatically convert voice messages and call recordings into searchable text transcripts.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "Help Center Search Indexing",
        "DESCRIPTION": "Use AI for context aware search inside your help center articles."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "Label Suggestion",
        "DESCRIPTION": "Automatically suggest relevant labels and tags for conversations based on content analysis and context.",
        "MODEL_TITLE": "Label Suggestion Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for analyzing conversations and suggesting appropriate labels"
      }
    },
    "API": {
      "SUCCESS": "Captain settings updated successfully.",
      "ERROR": "Failed to update Captain settings. Please try again."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "صورتحساب",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "طرح فعلی",
      "PLAN_NOTE": "شما در حال حاضر مشترک طرح **{plan}** با مجوز **{quantity}** هستید",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "اشتراک خود را مدیریت کنید",
      "DESCRIPTION": "فاکتورهای قبلی خود را مشاهده کنید، جزئیات صورتحساب خود را ویرایش کنید یا اشتراک خود را لغو کنید.",
      "BUTTON_TXT": "برو به پورتال صورتحساب"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more.",
      "REFRESH_CREDITS": "تازه کردن"
    },
    "CHAT_WITH_US": {
      "TITLE": "به کمک احتياج داری؟",
      "DESCRIPTION": "آیا در صورتحساب با مشکلی مواجه هستید؟ ما اینجاییم تا کمک کنیم.",
      "BUTTON_TXT": "با ما گفتگو کنید"
    },
    "NO_BILLING_USER": "صورتحساب حساب شما در حال پیکربندی است. لطفا صفحه را مجددا بارگزاری کرده و دوباره تلاش کنید.",
    "TOPUP": {
      "BUY_CREDITS": "Buy more credits",
      "MODAL_TITLE": "Buy AI Credits",
      "MODAL_DESCRIPTION": "Purchase additional credits for Captain AI.",
      "CREDITS": "CREDITS",
      "ONE_TIME": "one-time",
      "POPULAR": "Most Popular",
      "NOTE_TITLE": "یادداشت:",
      "NOTE_DESCRIPTION": "Credits are added immediately and expire in 6 months. An active subscription is required to use credits. Purchased credits are consumed after your monthly plan credits.",
      "CANCEL": "انصراف",
      "PURCHASE": "Purchase Credits",
      "LOADING": "Loading options...",
      "FETCH_ERROR": "Failed to load credit options. Please try again.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "Failed to process purchase. Please try again.",
      "PURCHASE_SUCCESS": "Successfully added {credits} credits to your account",
      "CONFIRM": {
        "TITLE": "Confirm Purchase",
        "DESCRIPTION": "You are about to purchase {credits} credits for {amount}.",
        "INSTANT_DEDUCTION_NOTE": "Your saved card will be charged immediately upon confirmation.",
        "GO_BACK": "بازگشت",
        "CONFIRM_PURCHASE": "Confirm Purchase"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "Security",
    "DESCRIPTION": "Manage your account security settings.",
    "LINK_TEXT": "Learn more about SAML SSO",
    "SAML_DISABLED_MESSAGE": "SAML SSO is currently disabled. Please contact your administrator to enable this feature.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "Configure SAML single sign-on for your account. Users will authenticate through your identity provider instead of using email/password.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "Assertion Consumer Service URL - Configure this URL in your IdP as the destination for SAML responses"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "The URL where SAML authentication requests will be sent",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "Signing certificate in PEM format",
        "HELP": "The public certificate from your identity provider used to verify SAML responses",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "Fingerprint",
        "TOOLTIP": "SHA-1 fingerprint of the certificate - Use this to verify the certificate in your IdP configuration"
      },
      "COPY_SUCCESS": "کد به حافظه کپی شد",
      "SP_ENTITY_ID": {
        "LABEL": "SP Entity ID",
        "HELP": "Unique identifier for this application as a service provider (auto-generated).",
        "TOOLTIP": "Unique identifier for Chatwoot as the Service Provider - Configure this in your IdP settings"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "Identity Provider Entity ID",
        "HELP": "Unique identifier for your identity provider (usually found in IdP configuration)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "Update SAML Settings",
      "API": {
        "SUCCESS": "SAML settings updated successfully",
        "ERROR": "Failed to update SAML settings",
        "ERROR_LOADING": "Failed to load SAML settings",
        "DISABLED": "SAML settings disabled successfully"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, Identity Provider Entity ID, and Certificate are required fields",
        "SSO_URL_ERROR": "Please enter a valid SSO URL",
        "CERTIFICATE_ERROR": "Certificate is required",
        "IDP_ENTITY_ID_ERROR": "Identity Provider Entity ID is required"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade to an Enterprise plan to access SAML single sign-on and other advanced security features.",
        "ASK_ADMIN": "لطفاً برای ارتقا با ادمین خود تماس بگیرید."
      },
      "PAYWALL": {
        "TITLE": "Upgrade to enable SAML SSO",
        "AVAILABLE_ON": "The SAML SSO feature is only available in the Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to get access to SAML single sign-on and other advanced features.",
        "UPGRADE_NOW": "حالا ارتقا دهید",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML Attribute Setup",
        "DESCRIPTION": "The following attribute mappings must be configured in your identity provider"
      },
      "INFO_SECTION": {
        "TITLE": "Service Provider Information",
        "TOOLTIP": "Copy these values and configure them in your Identity Provider to establish the SAML connection"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Conversation Workflows",
        "DESCRIPTION": "Configure rules and required fields for conversation resolution."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "Attributes required on resolution",
      "DESCRIPTION": "When resolving a conversation, agents will be prompted to fill these attributes if they haven't yet.",
      "NO_ATTRIBUTES": "No attributes added yet",
      "ADD": {
        "TITLE": "Add Attributes",
        "SEARCH_PLACEHOLDER": "جستجو ویژگی ها"
      },
      "SAVE": {
        "SUCCESS": "Required attributes updated",
        "ERROR": "Could not update required attributes, please try again"
      },
      "MODAL": {
        "TITLE": "گفتگو حل شده",
        "DESCRIPTION": "Please fill in the following custom attributes before resolving this conversation",
        "ACTIONS": {
          "RESOLVE": "گفتگو حل شده",
          "CANCEL": "انصراف"
        },
        "PLACEHOLDERS": {
          "TEXT": "Write a note...",
          "NUMBER": "Enter a number",
          "LINK": "Add a link",
          "DATE": "Pick a date",
          "LIST": "Select an option"
        },
        "CHECKBOX": {
          "YES": "بله",
          "NO": "خیر"
        }
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use required attributes",
        "AVAILABLE_ON": "The required conversation attributes feature is available on the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Upgrade your plan to prompt agents to fill required attributes before conversation resolution.",
        "UPGRADE_NOW": "حالا ارتقا دهید",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "The required conversation attributes feature is available on the paid plans.",
        "UPGRADE_PROMPT": "Upgrade to a paid plan to enforce required attributes before conversation resolution.",
        "ASK_ADMIN": "لطفاً برای ارتقا با ادمین خود تماس بگیرید."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "اوه اوه! ما هیچ حسابی روی Chatwoot پاز شما پیدا نکردیم. لطفاً برای ادامه یک حساب جدید ایجاد کنید.",
    "NEW_ACCOUNT": "حساب‌کاربری جدید",
    "SELECTOR_SUBTITLE": "ایجاد حساب‌کاربری جدید",
    "API": {
      "SUCCESS_MESSAGE": "حساب‌کاربری با موفقیت ایجاد شد",
      "EXIST_MESSAGE": "این حساب‌کاربری از قبل وجود دارد",
      "ERROR_MESSAGE": "ارتباط با سرور برقرار نشد، لطفا مجددا امتحان کنید"
    },
    "FORM": {
      "NAME": {
        "LABEL": "نام شرکت",
        "PLACEHOLDER": "شرکت ایران ناسیونال"
      },
      "SUBMIT": "ثبت",
      "CANCEL": "انصراف"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "مشاهده همه کلیدهای میانبر",
    "TITLE": {
      "OPEN_CONVERSATION": "باز کردن گفتگو",
      "RESOLVE_AND_NEXT": "حل کنید و به مرحله بعدی بروید",
      "NAVIGATE_DROPDOWN": "به موارد کشویی بروید",
      "RESOLVE_CONVERSATION": "حل مکالمه",
      "GO_TO_CONVERSATION_DASHBOARD": "به پیشخوان گفتگو بروید",
      "ADD_ATTACHMENT": "افزودن پیوست",
      "GO_TO_CONTACTS_DASHBOARD": "به پیشخوان مخاطبین بروید",
      "TOGGLE_SIDEBAR": "نوار کناری",
      "GO_TO_REPORTS_SIDEBAR": "به نوار کناری گزارش ها بروید",
      "MOVE_TO_NEXT_TAB": "به برگه بعدی در فهرست مکالمه بروید",
      "GO_TO_SETTINGS": "برو به تنظیمات",
      "SWITCH_TO_PRIVATE_NOTE": "رفتن به یادداشت خصوصی",
      "SWITCH_TO_REPLY": "رفتن به پاسخ",
      "TOGGLE_SNOOZE_DROPDOWN": "تغییر حالت بازکردن تعویق"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "Agent assignment",
        "DESCRIPTION": "Define policies to effectively manage workload and route conversations based on the needs of inboxes and agents. Learn more here"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "Assignment policy",
        "DESCRIPTION": "Manage how conversations get assigned in inboxes.",
        "FEATURES": [
          "Assign by conversations evenly or by available capacity",
          "Add fair distribution rules to avoid overloading any agent",
          "Add inboxes to a policy - one policy per inbox"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "Agent capacity policy",
        "DESCRIPTION": "Manage workload for agents.",
        "FEATURES": [
          "Define maximum conversations per inbox",
          "Create exceptions based on labels and time",
          "Add agents to a policy - one policy per agent"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Assignment policy",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "ORDER": "Order",
          "PRIORITY": "اولویت",
          "ACTIVE": "فعال",
          "INACTIVE": "Inactive",
          "POPOVER": "Added inboxes",
          "EDIT": "ویرایش"
        },
        "NO_RECORDS_FOUND": "No assignment policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create assignment policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy created successfully",
          "ERROR_MESSAGE": "Failed to create assignment policy",
          "INBOX_LINKED": "Inbox has been linked to the policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit assignment policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "Add inbox",
          "DESCRIPTION": "{inboxName} inbox is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "انصراف"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "Link inbox to policy",
          "DESCRIPTION": "Would you like to link this inbox to the assignment policy?",
          "LINK_BUTTON": "Link inbox",
          "CANCEL_BUTTON": "Skip"
        },
        "API": {
          "SUCCESS_MESSAGE": "Assignment policy updated successfully",
          "ERROR_MESSAGE": "Failed to update assignment policy"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox added to policy successfully",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Inbox removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove inbox from policy"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "توضیحات:",
          "PLACEHOLDER": "Enter description"
        },
        "STATUS": {
          "LABEL": "وضعیت:",
          "PLACEHOLDER": "Select status",
          "ACTIVE": "Policy is active",
          "INACTIVE": "Policy is inactive"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "Assignment order",
          "ROUND_ROBIN": {
            "LABEL": "Round robin",
            "DESCRIPTION": "Assign conversations evenly among agents."
          },
          "BALANCED": {
            "LABEL": "Balanced",
            "DESCRIPTION": "Assign conversations based on available capacity.",
            "PREMIUM_MESSAGE": "Upgrade to access balanced assignment and agent capacity management.",
            "PREMIUM_BADGE": "Premium"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "Assignment priority",
          "EARLIEST_CREATED": {
            "LABEL": "Earliest created",
            "DESCRIPTION": "The conversation that was created first gets assigned first."
          },
          "LONGEST_WAITING": {
            "LABEL": "Longest waiting",
            "DESCRIPTION": "The conversation waiting the longest gets assigned first."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "Fair distribution policy",
          "DESCRIPTION": "Set the maximum number of conversations that can be assigned per agent within a time window to avoid overloading any one agent. This required field defaults to 100 conversations per hour.",
          "INPUT_MAX": "Assign max",
          "DURATION": "Conversations per agent in every"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "Added inboxes",
          "DESCRIPTION": "Add inboxes for which this policy will be applicable.",
          "ADD_BUTTON": "Add inbox",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select inboxes to add",
            "ADD_BUTTON": "افزودن"
          },
          "EMPTY_STATE": "No inboxes added to this policy, add an inbox to get started",
          "API": {
            "SUCCESS_MESSAGE": "Inbox successfully added to policy",
            "ERROR_MESSAGE": "Failed to add inbox to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Assignment policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete assignment policy"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "Agent capacity",
          "CREATE_POLICY": "New policy"
        },
        "CARD": {
          "POPOVER": "Added agents",
          "EDIT": "ویرایش"
        },
        "NO_RECORDS_FOUND": "No agent capacity policies found"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "Create agent capacity policy"
        },
        "CREATE_BUTTON": "Create policy",
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy created successfully",
          "ERROR_MESSAGE": "Failed to create agent capacity policy"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "Edit agent capacity policy"
        },
        "EDIT_BUTTON": "Update policy",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "Add agent",
          "DESCRIPTION": "{agentName} is already linked to another policy. Are you sure you want to link it to this policy? It will be unlinked from the other policy.",
          "CONFIRM_BUTTON_LABEL": "Continue",
          "CANCEL_BUTTON_LABEL": "انصراف"
        },
        "API": {
          "SUCCESS_MESSAGE": "Agent capacity policy updated successfully",
          "ERROR_MESSAGE": "Failed to update agent capacity policy"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Agent added to policy successfully",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "Agent removed from policy successfully",
            "ERROR_MESSAGE": "Failed to remove agent from policy"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "Inbox limit added successfully",
            "ERROR_MESSAGE": "Failed to add inbox limit"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "Inbox limit updated successfully",
            "ERROR_MESSAGE": "Failed to update inbox limit"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "Inbox limit deleted successfully",
            "ERROR_MESSAGE": "Failed to delete inbox limit"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "Policy name:",
          "PLACEHOLDER": "Enter policy name"
        },
        "DESCRIPTION": {
          "LABEL": "توضیحات:",
          "PLACEHOLDER": "Enter description"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "Inbox capacity limits",
          "ADD_BUTTON": "Add inbox",
          "FIELD": {
            "SELECT_INBOX": "Select inbox",
            "MAX_CONVERSATIONS": "Max conversations",
            "SET_LIMIT": "Set limit"
          },
          "EMPTY_STATE": "No inbox limit set"
        },
        "EXCLUSION_RULES": {
          "LABEL": "Exclusion rules",
          "DESCRIPTION": "Conversations that satisfy the following conditions would not count towards agent capacity",
          "TAGS": {
            "LABEL": "Exclude conversations tagged with specific labels",
            "ADD_TAG": "add tag",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "Search and select tags to add"
            },
            "EMPTY_STATE": "No tags added to this policy."
          },
          "DURATION": {
            "LABEL": "Exclude conversations older than a specified duration",
            "PLACEHOLDER": "Set time"
          }
        },
        "USERS": {
          "LABEL": "Assigned agents",
          "DESCRIPTION": "Add agents for which this policy will be applicable.",
          "ADD_BUTTON": "Add agent",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "Search and select agents to add",
            "ADD_BUTTON": "افزودن"
          },
          "EMPTY_STATE": "No agents added",
          "API": {
            "SUCCESS_MESSAGE": "Agent successfully added to policy",
            "ERROR_MESSAGE": "Failed to add agent to policy"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "Agent capacity policy deleted successfully",
        "ERROR_MESSAGE": "Failed to delete agent capacity policy"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "Delete policy",
      "DESCRIPTION": "Are you sure you want to delete this policy? This action cannot be undone.",
      "CONFIRM_BUTTON_LABEL": "حذف",
      "CANCEL_BUTTON_LABEL": "انصراف"
    }
  }
}
